import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<input\n  class={{this.classNames}}\n  placeholder={{this.placeholder}}\n  ...attributes\n  value={{@value}}\n  type={{this.type}}\n/>")